<template>
  <layout class="drivers-list-page-container">
    <div class="w-full adm-container flex sm:flex-col lg:flex-row">
      <div class="filter-dropdown-container sm:mb-4 lg:mb-0 sm:mr-0 lg:mr-4 sm:w-full lg:w-1/5">
        <pt-dropdown
          :right="false"
          :text="dropDownItems[selectedFilter]"
          class="w-full"
        >
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'All Drivers'}"
            @dd-item-clicked="filterList(null, 'All Drivers')">{{ dropDownItems['All Drivers'] }}</pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'Active'}"
            @dd-item-clicked="filterList('status', 'Active')"
          >{{ dropDownItems['Active'] }}</pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'Online'}"
            @dd-item-clicked="filterList('realtime', 'Online')"
          >
            <span>
              <div class="w-2 h-2 mr-2 rounded-full border border-green bg-white" /> {{ dropDownItems['Online'] }}
            </span>
          </pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'ACCEPTED'}"
            @dd-item-clicked="filterList('realtime', 'ACCEPTED')"
          >
            <span>
              <div class="w-2 h-2 mr-2 rounded-full bg-blue" /> {{ dropDownItems['ACCEPTED'] }}
            </span>
          </pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'WAITING'}"
            @dd-item-clicked="filterList('realtime', 'WAITING')"
          >
            <span>
              <div class="w-2 h-2 mr-2 rounded-full bg-yellow" /> {{ dropDownItems['WAITING'] }}
            </span>
          </pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'STARTED'}"
            @dd-item-clicked="filterList('realtime', 'STARTED')"
          >
            <span>
              <div class="w-2 h-2 mr-2 rounded-full bg-green" /> {{ dropDownItems['STARTED'] }}
            </span>
          </pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'Offline'}"
            @dd-item-clicked="filterList('realtime', 'Offline')"
          >
            <span>
              <div class="w-2 h-2 mr-2 rounded-full border border-grey bg-white" /> {{ dropDownItems['Offline'] }}
            </span>
          </pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'Unverified'}"
            @dd-item-clicked="filterList('status', 'Unverified')"
          >{{ dropDownItems['Unverified'] }}</pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedFilter === 'Suspended'}"
            @dd-item-clicked="filterList('status', 'Suspended')"
          >{{ dropDownItems['Suspended'] }}</pt-dropdown-item>
        </pt-dropdown>
      </div>
      <div
        v-if="user.type !== 'bike'"
        class="filter-dropdown-container sm:mb-4 sm:w-full lg:mb-0 lg:w-1/5 sm:mr-0 lg:mr-4"
      >
        <pt-dropdown
          :right="false"
          :text="carTypeDropDownItems[selectedCarType]"
          class="w-full"
        >
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedCarType === 'All'}"
            @dd-item-clicked="filterByCarType('All')">{{ carTypeDropDownItems['All'] }}</pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedCarType === 'Car Plus'}"
            @dd-item-clicked="filterByCarType('Car Plus')"
          >{{ carTypeDropDownItems['Car Plus'] }}</pt-dropdown-item>
          <pt-dropdown-item
            :class="{'pt-dropdown-item-active': selectedCarType === 'Car Lite'}"
            @dd-item-clicked="filterByCarType('Car Lite')"
          >{{ carTypeDropDownItems['Car Lite'] }}</pt-dropdown-item>
        </pt-dropdown>
      </div>
      <div :class="{ 'search-input relative sm:mb-4 lg:mb-0 sm:w-full sm:mr-0 lg:mr-4': true, 'lg:w-2/5': user.type !== 'bike', 'lg:w-3/5': user.type === 'bike'}">
        <div class="w-full h-full flex items-center justify-center">
          <div class="sm:hidden lg:w-1/5" />
          <div class="sm:w-full lg:w-3/5">
            <suggestion-input
              :list="autoCompleteDriverList"
              :lookup-fields="['name', 'number']"
              accessor="name"
              placeholder="Search drivers by name or phone"
              icon-class="fa-search"
              icon-position="left"
              class="flex-1"
              @autocomplete-item-set="onAutoCompleteItemSelected"
              @autocomplete-cleared="onAutoCompleteItemCleared"
            >
              <div slot="noResult">No driver found</div>
            </suggestion-input>
          </div>
          <div class="sm:hidden lg:w-1/5" />
        </div>
      </div>
      <div class="flex items-center justify-end text-primary font-bold sm:mb-4 sm:w-full lg:mb-0 lg:w-1/5">
        <download-csv
          :download-url="csvUrl"
          file-name="Driver List"
        />
      </div>
    </div>
    <div
      class="w-full flex flex-col adm-container"
      @fetch-all-drivers="fetchDrivers()"
    >
      <div class="table-loader-container relative">
        <pt-list v-if="chunkDrivers.length">
          <div class="flex-1 p-4 border-b sm:hidden lg:flex">
            <div class="flex flex-1 font-bold items-center">
              <div class="w-1/3">Driver</div>
              <div
                v-if="user.type !== 'bike'"
                class="w-1/6">Driver Type</div>
              <div class="w-1/6">Status</div>
              <div class="w-1/6">Realtime</div>
              <div class="w-1/6">Mobile</div>
            </div>
            <div
              class="pull-right"
              style="width: 36px"
            >&nbsp;</div>
          </div>
          <pt-list-item
            v-for="(driverRow, driverIndex) in chunkDrivers"
            :key="driverIndex"
          >
            <div class="flex flex-1">
              <div class="flex flex-1 items-center sm:flex-col lg:flex-row">
                <div class="flex sm:w-full lg:w-1/3 sm:mb-2 lg:mb-0">
                  <pt-avatar
                    :type="driverRow['profile_picture'] ? 'image' : 'icon'"
                    :src="`https://cdn.pathao.com${driverRow['profile_picture']}`"
                    size="nn"
                    class="mr-4"
                    style="width: 30px; height: 30px"
                  />
                  <router-link
                    :to="`/driver/${driverRow.id}`"
                    class="flex no-underline cursor-pointer text-black hover:text-grey-darker items-center font-bold"
                  >{{ driverRow.name }}</router-link>
                </div>
                <div
                  v-if="user.type !== 'bike'"
                  class="sm:w-full lg:w-1/6 sm:mb-2 lg:mb-0">
                  <span class="font-bold items-center mr-4 lg:hidden">Driver Type: </span>
                  <span>{{ driverRow.driver_type }}</span>
                </div>
                <div class="sm:w-full lg:w-1/6 sm:mb-2 lg:mb-0">
                  <span class="font-bold items-center mr-4 lg:hidden">Status: </span>
                  <span>{{ driverRow.status }}</span>
                </div>
                <div class="sm:w-full lg:w-1/6 sm:mb-2 lg:mb-0">
                  <div class="w-full flex items-center">
                    <span class="font-bold items-center mr-4 lg:hidden">Realtime: </span>
                    <div :class="`w-2 h-2 mr-2 rounded-full ${getRealTimeIndicatorClass(driverRow.realtime)}`" />
                    <div>{{ getRealTimeLabel(driverRow.realtime) }}</div>
                  </div>
                </div>
                <div class="sm:w-full lg:w-1/6 sm:mb-2 lg:mb-0">
                  <span class="font-bold items-center mr-4 lg:hidden">Mobile: </span>
                  <span>{{ driverRow.phone }}</span>
                </div>
              </div>
              <div class="flex items-center justify-end">
                <div class="flex justify-end">
                  <pt-popover
                    :ref="`popoverClose-${driverRow.id}`"
                    placement="bottom"
                  >
                    <i
                      class="fa fa-ellipsis-v fa-lg cursor-pointer pl-4 pr-4 text-primary"
                      aria-hidden="true"
                    />
                    <div
                      slot="body"
                      class="popover-text cursor-pointer">
                      <span @click="removeCaptain(driverRow)">Remove From Admiral</span>
                    </div>
                  </pt-popover>
                  <pt-modal :ref="`actionModal-${driverRow.id}`">
                    <div slot="modal-body">Do you want to remove this driver from Admiral?</div>
                    <div
                      slot="modal-footer"
                      class="text-right mb-2 mr-2"
                    >
                      <button
                        class="font-bold py-2 px-4 rounded mr-4 w-16 border text-red border-red"
                        @click="closeModal(driverRow)"
                      >
                        No
                      </button>
                      <span class="relative">
                        <i
                          :ref="`loaderIcon-${driverRow.id}`"
                          style="left: 8px;font-size: 21px;top: 0px;"
                          class="invisible fa-li fa fa-spinner fa-spin text-primary outline-none"
                        />
                      </span>
                      <button
                        ref="`yesText-${driverRow.id}`"
                        class="bg-primary text-white font-bold py-2 px-4 rounded w-16 outline-none"
                        @click="removeCaptainConfirm(driverRow)">
                        Yes
                      </button>
                    </div>
                  </pt-modal>
                </div>
              </div>
            </div>
          </pt-list-item>
        </pt-list>
        <table-placeholder
          :is-syncing="isLoadingDriverList"
          :data-length="chunkDrivers.length"
          loader-class="text-black"
        />
      </div>
      <pt-pagination
        :total-rows="totalRows"
        :current-page="currentPage"
        :page-size="pageSize"
        class="mt-8"
        @page-changed="sliceDrivers"
      />
    </div>
  </layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import filter from 'lodash/filter';
import clone from 'lodash/clone';
import orderBy from 'lodash/orderBy';
import concat from 'lodash/concat';
import { PtDropdown, PtDropdownItem } from '@pathao/ui-components/esm/Dropdown';
import { PtViewTable } from '@pathao/ui-components/esm/Table';
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import { PtPopover } from '@pathao/ui-components/esm/Popover';
import { PtModal } from '@pathao/ui-components/esm/Modal';
import { PtButton } from '@pathao/ui-components/esm/Button';
import { PtLoader } from '@pathao/ui-components/esm/Loader';
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';
import Layout from '@layouts/main';
import makeRequest from '@utils/apiRequest';
import Config from '@config';
import PaginationConfig from '@config/pagination';
import SuggestionInput from '@components/custom/SuggestionInput';
import TablePlaceholder from '@components/custom/TablePlaceholder';
import PtAvatar from '@components/custom/Avatar';
import DownloadCsv from '@components/custom/DownloadCsv';
import SliceData from '@utils/slice-data';

const DRIVER_LIST_BASE_URL = `${Config.api.baseURL}api/partners/drivers/list`;
const allDriversFilter = 'All Drivers';
const allCarsFilter = 'All';

export default {
  name: 'Drivers',
  page: {
    title: 'Drivers',
  },
  components: { PtAvatar, SuggestionInput, PtDropdown, PtDropdownItem, PtViewTable, PtPagination, Layout, PtPopover, PtModal, PtButton, PtLoader, TablePlaceholder, DownloadCsv, PtList, PtListItem },
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      statusHandler: [],
      driversList: [],
      chunkDrivers: [],
      selectedFilter: allDriversFilter,
      filterType: null,
      selectedCarType: allCarsFilter,
      totalRows: 0,
      currentPage: PaginationConfig.CURRENT_PAGE,
      pageSize: PaginationConfig.PAGE_SIZE,
      filteredDriverId: null,
      filteredStatus: null,
      filteredRealTime: null,
      isLoadingDriverList: false,
    };
  },
  computed: {
    ...mapGetters({
      autoCompleteDriverList: 'drivers/drivers',
    }),
    csvUrl() {
      const baseUrl = `${DRIVER_LIST_BASE_URL}/export`;
      const paramList = [];

      if (this.filterType && this.selectedFilter) {
        paramList.push(`filterBy${this.filterType}=${this.selectedFilter}`);
      }

      if (this.selectedCarType) {
        paramList.push(`filterByCarType=${this.selectedCarType}`);
      }

      if (this.filteredDriverId) {
        paramList.push(`filterByDriverId=${this.filteredDriverId}`);
      }

      return paramList.length ? `${baseUrl}?${paramList.join('&')}` : baseUrl;
    },
    activeDrivers() {
      return this.filterDriversListByProperty('status', 'Active');
    },
    onTripDrivers() {
      return this.filterDriversListByProperty('realtime', 'On Trip', this.activeDrivers);
    },
    acceptedDrivers() {
      return this.filterDriversListByProperty('realtime', 'ACCEPTED', this.activeDrivers);
    },
    waitingDrivers() {
      return this.filterDriversListByProperty('realtime', 'WAITING', this.activeDrivers);
    },
    onlineDrivers() {
      return this.filterDriversListByProperty('realtime', 'Online', this.activeDrivers);
    },
    offlineDrivers() {
      return this.filterDriversListByProperty('realtime', 'Offline', this.activeDrivers);
    },
    suspendedDrivers() {
      return this.filterDriversListByProperty('status', 'Suspended');
    },
    unverifiedDrivers() {
      return this.filterDriversListByProperty('status', 'Unverified');
    },
    currentStatusDrivers() {
      if (this.selectedFilter !== allDriversFilter) {
        const status = this.filterDriversListByProperty('status', this.selectedFilter);
        const realTime = this.filterDriversListByProperty('realtime', this.selectedFilter === 'STARTED' ? 'On Trip' : this.selectedFilter);

        return concat([], status, realTime);
      }

      return this.driversList;
    },
    carPlusDrivers() {
      if (this.user.type !== 'bike') {
        return this.filterDriversListByProperty('driver_type', 'Car Plus', this.currentStatusDrivers);
      }

      return [];
    },
    carLiteDrivers() {
      if (this.user.type !== 'bike') {
        return this.filterDriversListByProperty('driver_type', 'Car Lite', this.currentStatusDrivers);
      }

      return [];
    },
    dropDownItems() {
      return {
        'All Drivers': `All Drivers (${this.driversList.length})`,
        'Active': `Active (${this.activeDrivers.length})`,
        'STARTED': `On Trip (${this.onTripDrivers.length})`,
        'ACCEPTED': `Accepted (${this.acceptedDrivers.length})`,
        'WAITING': `Waiting (${this.waitingDrivers.length})`,
        'Online': `Online (${this.onlineDrivers.length})`,
        'Offline': `Offline (${this.offlineDrivers.length})`,
        'Suspended': `Suspended (${this.suspendedDrivers.length})`,
        'Unverified': `Unverified (${this.unverifiedDrivers.length})`,
      };
    },
    carTypeDropDownItems() {
      return {
        'All': `All (${this.currentStatusDrivers.length})`,
        'Car Plus': `Car Plus (${this.carPlusDrivers.length})`,
        'Car Lite': `Car Lite (${this.carLiteDrivers.length})`,
      };
    },
  },
  created() {
    this.$root.$on('reload-driver', this.fetchDrivers);
  },
  beforeDestroy() {
    this.$root.$off('reload-driver', this.fetchDrivers);
  },
  mounted() {
    this.fetchDrivers();
  },
  methods: {
    ...mapActions({
      fetchDriverListWithInfo: 'drivers/fetchDrivers',
    }),
    getRealTimeLabel(realtime) {
      let label;
      switch (realtime) {
        case 'STARTED':
          label = 'On Trip';
          break;
        case 'ACCEPTED':
          label = 'Accepted';
          break;
        case 'WAITING':
          label = 'Waiting';
          break;
        default:
          label = realtime;
          break;
      }

      return label;
    },
    fetchDrivers() {
      this.fetchDriverListWithInfo();
      this.fetchDriverListWithStatus();
    },
    filterList(type, key) {
      this.filterType = type;
      this.selectedFilter = key;
      this.sliceDrivers();
    },
    filterByCarType(key) {
      this.selectedCarType = key;
      this.sliceDrivers();
    },
    onAutoCompleteItemSelected(suggestionItem) {
      this.filteredDriverId = suggestionItem.id;
      this.sliceDrivers();
    },
    onAutoCompleteItemCleared() {
      this.filteredDriverId = null;
      this.sliceDrivers();
    },
    async fetchDriverListWithStatus(currentPage = PaginationConfig.CURRENT_PAGE, pageSize = PaginationConfig.PAGE_SIZE) {
      this.driversList = [];
      this.isLoadingDriverList = true;
      try {
        const response = await makeRequest({
          url: '/api/partners/drivers/list',
        });

        this.driversList = response.data.data;
        this.sortDriversList();
        this.sliceDrivers(currentPage, pageSize);
      } catch (e) {
        this.$notification.error('Drivers not found');
      } finally {
        this.isLoadingDriverList = false;
      }
    },
    filterDriversListByProperty(key, value, lookUpArray = this.driversList) {
      return filter(lookUpArray, (driver) => {
        return driver[key] === value;
      });
    },
    sortDriversList() {
      const onTrip = orderBy(this.onTripDrivers, ['name'], ['asc']);
      const accepted = orderBy(this.acceptedDrivers, ['name'], ['asc']);
      const waiting = orderBy(this.waitingDrivers, ['name'], ['asc']);
      const online = orderBy(this.onlineDrivers, ['name'], ['asc']);
      const offline = orderBy(this.offlineDrivers, ['name'], ['asc']);
      const suspended = orderBy(this.suspendedDrivers, ['name'], ['asc']);
      const unverified = orderBy(this.unverifiedDrivers, ['name'], ['asc']);

      this.driversList = concat([], onTrip, accepted, waiting, online, offline, suspended, unverified);
    },
    sliceDrivers(currentPage = PaginationConfig.CURRENT_PAGE, pageSize = PaginationConfig.PAGE_SIZE) {
      this.isLoadingDriverList = true;

      const filteredList = this.getFilteredList();
      this.chunkDrivers = SliceData(filteredList, currentPage, pageSize);
      this.totalRows = filteredList.length || 0;
      this.currentPage = currentPage;
      this.pageSize = pageSize;
      this.isLoadingDriverList = false;
    },
    getFilteredList() {
      let filteredList = clone(this.driversList);

      if (this.filteredDriverId) {
        filteredList = filter(filteredList, (currentDriver) => {
          return this.filteredDriverId === currentDriver.id;
        });
      }

      if (this.selectedFilter !== allDriversFilter) {
        filteredList = filter(filteredList, (currentDriver) => {
          const filter = this.selectedFilter === 'STARTED' ? 'On Trip' : this.selectedFilter;
          return currentDriver.realtime === filter || currentDriver.status === filter;
        });
      }

      if (this.user.type !== 'bike' && this.selectedCarType !== allCarsFilter) {
        filteredList = filter(filteredList, (currentDriver) => {
          return currentDriver.driver_type === this.selectedCarType;
        });
      }

      return filteredList;
    },
    getRemoveCaptainRelatedComponentForDriver(driverId, componentType) {
      const comp = this.$refs[`${componentType}-${driverId}`];

      return comp ? comp[0] : null;
    },
    removeCaptain(driver) {
      const actionModal = this.getRemoveCaptainRelatedComponentForDriver(driver.id, 'actionModal');
      const popOverClose = this.getRemoveCaptainRelatedComponentForDriver(driver.id, 'popoverClose');

      if (actionModal) {
        actionModal.showModal();
      }

      if (popOverClose) {
        popOverClose.doToggle();
      }
    },
    closeModal(driver) {
      const actionModal = this.getRemoveCaptainRelatedComponentForDriver(driver.id, 'actionModal');

      if (actionModal) {
        actionModal.closeModal();
      }
    },
    removeCaptainConfirm(driver) {
      const loaderIcon = this.getRemoveCaptainRelatedComponentForDriver(driver.id, 'loaderIcon');
      const yesText = this.getRemoveCaptainRelatedComponentForDriver(driver.id, 'yesText');

      if (loaderIcon) {
        loaderIcon.classList.remove('invisible');
      }

      if (yesText) {
        yesText.classList.add('invisible');
      }

      this.$store.dispatch('drivers/deleteCaptain', driver.id)
        .then(response => {
          const actionModal = this.getRemoveCaptainRelatedComponentForDriver(driver.id, 'actionModal');

          if (actionModal) {
            actionModal.closeModal();
          }

          if (response && response.status.toLowerCase() === 'success') {
            this.$notification.success('Driver removed successfully! Reloading drivers List');
            this.$ga.event({
              eventCategory: 'Pairing',
              eventAction: 'Partner-Driver',
              eventLabel: 'Unpaired',
            });
            // this.$root.$emit('reload-driver');
            this.fetchDriverListWithStatus();
          } else {
            this.$notification.error('Something went wrong!');
          }
        });
    },
    getRealTimeIndicatorClass(realtime) {
      let indicatorClass = '';

      switch (realtime.toLowerCase()) {
        case 'on trip':
        case 'started':
          indicatorClass = 'bg-green';
          break;
        case 'online':
          indicatorClass = 'border border-green bg-white';
          break;
        case 'accepted':
          indicatorClass = 'bg-blue';
          break;
        case 'offline':
          indicatorClass = 'border border-grey bg-white';
          break;
        case 'waiting':
          indicatorClass = 'bg-yellow';
          break;
      }

      return indicatorClass;
    },
  },
};
</script>
